import React, { Fragment, useState, useEffect, useMemo } from "react";
import Breadcrumb from "../../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import { change_Lang } from "../../../actions/Helper_action";
import { Search } from "react-feather";
import {
  View_Bills_Security,
  Get_List_Scurety_Bills,
  Scurety_Delete,
} from "../../../actions_agent/Invoice_action";
import { isMobile } from "react-device-detect";
import { Button, Input, Modal, Tooltip, Switch } from "antd";
import Swal from "sweetalert2";
import View_Scurity from "./View_Scurity";
const ScurityList = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.AuthReducer.user);
  const [hideDirector, setHideDirector] = useState(false);
  const [isModalVisible, setisModalVisible] = useState(false);
  useEffect(() => {
    dispatch(Get_List_Scurety_Bills());
    if (user && user.v_scurety !== false) {
      setHideDirector(false);
    } else {
      setHideDirector(true);
    }
  }, []);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const list_scurety = useSelector(
    (state) => state.Invoice_Reducer.list_scurety
  );
  const [search, setsearch] = useState("");
  const Scurety_getPrint = () => {
    window.setTimeout("window.print()", 3000);
  };
  const showModal = (id) => {
    setisModalVisible(true);
    dispatch(View_Bills_Security(id));
  };
  const handleCancel = () => {
    setisModalVisible(false);
  };
  const onDelete_Scurity = (id) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      html: `<label>${dispatch(
        change_Lang("You won't be able to delete this!")
      )}</label>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(Scurety_Delete(id));
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          timer: 1000,
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
        });
      }
    });
  };
  const [showModal_, setShowModal] = useState(false);
  const toggleModal = () => {
    setShowModal(!showModal_);
  };
  const initialColumns = useMemo(() => {
    return [
      {
        name: dispatch(change_Lang("id")),
        selector: "id",
        sortable: true,
        center: true,
        compact: true,
        visibility: true,
      },
      {
        name: dispatch(change_Lang("security base")),
        selector: "scuertyName",
        center: true,
        compact: true,
        visibility: true,
      },
      {
        name: dispatch(change_Lang("Owner Name")),
        selector: "ownername",
        center: true,
        compact: true,
        visibility: true,
      },
      {
        name: dispatch(change_Lang("The name of the tenant")),
        selector: "tenantname",
        center: true,
        compact: true,
        visibility: true,
      },
      {
        name: dispatch(change_Lang("date")),
        selector: "date",
        center: true,
        compact: true,
        visibility: true,
      },
      {
        name: dispatch(change_Lang("Action")),
        selector: "action",
        center: true,
        compact: true,
        omit: hideDirector,
        visibility: true,
      },
    ];
  }, [hideDirector]);
  const [columns, setColumns] = useState(initialColumns);
  const handleColumnToggle = (columnKey) => {
    setColumns((prevColumns) =>
      prevColumns.map((column) =>
        column.selector === columnKey
          ? { ...column, visibility: !column.visibility }
          : column
      )
    );
  };
  const datas = list_scurety
    .filter((data) => {
      if (search !== "") {
        if (isNaN(search)) {
          if (
            data.scuertyName &&
            data.scuertyName.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return data.scuertyName
              .toLowerCase()
              .startsWith(search.toLowerCase());
          } else if (
            data.ownername &&
            data.ownername.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return (
              data.ownername &&
              data.ownername.toLowerCase().startsWith(search.toLowerCase())
            );
          } else if (
            data.tenantname &&
            data.tenantname.toLowerCase().startsWith(search.toLowerCase())
          ) {
            return (
              data.tenantname &&
              data.tenantname.toLowerCase().startsWith(search.toLowerCase())
            );
          }
        }
      } else {
        return data;
      }
    })
    .map((el, i) => {
      return {
        id: list_scurety.length - i,
        scuertyName: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.scuertyName}
          </span>
        ),
        ownername: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{el.ownername}</span>
        ),
        tenantname: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.tenantname}
          </span>
        ),
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
            className={`${lang === "en" ? "" : "fk"}`}
          />
        ),
        action: (
          <>
            <Tooltip title="View">
              <Button
                style={{ background: "#efefed", color: "#295a68" }}
                shape="circle"
                onClick={() => showModal(el._id)}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-eye text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
            &nbsp;
            <Tooltip title="Print">
              <Link to={`/print_view_asyash`}>
                <Button
                  style={{ background: "#efefed", color: "#295a68" }}
                  shape="circle"
                  onClick={() => {
                    dispatch(View_Bills_Security(el._id));
                    Scurety_getPrint();
                  }}
                  icon={
                    <i
                      style={{
                        cursor: "pointer",
                      }}
                      className="fas fa-print text-center mt-1"
                    ></i>
                  }
                />
              </Link>
            </Tooltip>
            &nbsp;
            {user.d_scurety !== false ? (
              <Tooltip title="Delete">
                <Button
                  style={{ background: "#efefed", color: "#295a68" }}
                  shape="circle"
                  onClick={() => onDelete_Scurity(el._id)}
                  icon={
                    <i
                      style={{
                        cursor: "pointer",
                      }}
                      className="fas fa-ban text-center mt-1"
                    ></i>
                  }
                />
              </Tooltip>
            ) : (
              ""
            )}
          </>
        ),
      };
    });
  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("Security Bill List"))}
          parent={dispatch(change_Lang("Security Bill"))}
        />
        <div
          className={`${
            lang === "en" ? "container-fluid" : "container-fluid fk"
          }`}
        >
          <div className="row">
            <div className="col-xs-12 col-sm-12 ">
              <div className={isMobile ? "" : "card"}>
                <div className="row ">
                  <div
                    className={
                      isMobile
                        ? "col-md-4 d-flex justify-content-center"
                        : "col-md-3 card-header d-flex justify-content-start"
                    }
                  >
                    <div className=" text-center ">
                      <Link to="/pswlay_Asaysh">
                        <button className="btn m-auto btn-sm p-2 exp_btn">
                          {dispatch(change_Lang("Security Bill"))}
                        </button>
                      </Link>
                    </div>
                  </div>
                  <div
                    className={isMobile ? "col-md-6" : "col-md-6 card-header"}
                  >
                    <div className=" text-center mt-2">
                      <h3 style={{ fontWeight: "bold", color: "#295a68" }}>
                        {dispatch(change_Lang("Security Bill List"))}
                      </h3>
                    </div>
                  </div>
                  <div
                    className={
                      isMobile
                        ? "col-md-3 d-flex justify-content-center form-inline"
                        : "col-md-3 d-flex justify-content-start form-inline"
                    }
                  >
                    <Input
                      type="text"
                      name="search"
                      value={search}
                      onChange={(e) => setsearch(e.target.value)}
                      size="middle"
                      placeholder={dispatch(change_Lang("Search"))}
                      autoComplete="off"
                      style={{ width: "180px" }}
                      prefix={<Search color="lightgray" />}
                    />
                    &nbsp;&nbsp;
                    <span className="">
                      <button
                        onClick={toggleModal}
                        className="btn m-auto btn-sm p-1 exp_btn "
                      >
                        <i className="fa-solid fa-bars"></i>
                      </button>
                    </span>
                  </div>
                </div>
                <div className="row user-status table-responsive latest-order-table table-striped">
                  <DataTable
                    columns={columns.filter((column) => column.visibility)}
                    className={`${lang === "en" ? "" : "fk"}`}
                    customStyles={customStyles}
                    data={datas}
                    pagination={true}
                    noDataComponent={dispatch(change_Lang("table_display"))}
                    striped
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          title="Select Columns"
          open={showModal_}
          onCancel={toggleModal}
          width={390}
          footer={[
            <Button key="close" onClick={toggleModal}>
              Close
            </Button>,
          ]}
        >
          {columns.map((column) => (
            <div
              className="row d-flex justify-content-center"
              key={column.selector}
              style={{ marginBottom: 16, textAlign: "justify" }}
            >
              <span
                className="col-5 fk"
                style={{ marginLeft: 8, fontSize: "15px" }}
              >
                {column.name}
              </span>
              <Switch
                checked={column.visibility}
                style={{
                  background: column.visibility ? "#5172dd" : "#babbba",
                }}
                className="col-1"
                onChange={() => handleColumnToggle(column.selector)}
              />
            </div>
          ))}
        </Modal>
        <Modal
          title={dispatch(change_Lang("Sceurity Anket"))}
          footer={false}
          className="fk"
          width={1200}
          open={isModalVisible}
          onOk={handleCancel}
          onCancel={handleCancel}
          centered
          bodyStyle={{ background: "#f6f8fa" }}
        >
          <View_Scurity handleCancel={handleCancel} />
        </Modal>
      </Fragment>
    </>
  );
};

export default ScurityList;
